export const customTaxPayoutDetailsInfo: string = $localize`* according to the laws of the state of Maryland, in the case of payout has exceeded 5000 USD and is 300 times higher than your stake a 24% tax on winnings will be charged`;
